<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
  electionDate: { type: String, default: null },
});

const now = ref(Date.now());
let timer = null;

onMounted(() => {
  timer = setInterval(() => {
    now.value = Date.now();
  }, 1000);
});
onBeforeUnmount(() => {
  if (timer) clearInterval(timer);
});

const diff = computed(() => {
  if (!props.electionDate) return null;
  const target = new Date(`${props.electionDate}T08:00:00`).getTime();
  return target - now.value;
});

const parts = computed(() => {
  const d = diff.value;
  if (d === null) return null;
  const sign = d < 0 ? -1 : 1;
  const abs = Math.abs(d);
  return {
    past: sign < 0,
    days: Math.floor(abs / (86400 * 1000)),
    hours: Math.floor((abs % (86400 * 1000)) / (3600 * 1000)),
    minutes: Math.floor((abs % (3600 * 1000)) / (60 * 1000)),
    seconds: Math.floor((abs % (60 * 1000)) / 1000),
  };
});

const formatted = v => String(v).padStart(2, '0');
</script>

<template>
  <div
    class="overflow-hidden rounded-xl border border-n-strong/40 bg-gradient-to-br from-indigo-700 via-blue-700 to-purple-700 p-5 text-white"
  >
    <div
      class="mb-3 flex items-center gap-2 text-xs font-semibold uppercase opacity-80"
    >
      <span class="i-lucide-timer size-3.5" />
      {{ parts?.past ? 'Eleição já aconteceu há' : 'Até a eleição' }}
    </div>

    <div v-if="parts" class="flex items-center gap-3">
      <div class="text-center">
        <div class="font-mono text-5xl font-black tabular-nums">
          {{ parts.days }}
        </div>
        <div class="text-[10px] uppercase opacity-80">dias</div>
      </div>
      <div class="text-4xl opacity-50">:</div>
      <div class="text-center">
        <div class="font-mono text-5xl font-black tabular-nums">
          {{ formatted(parts.hours) }}
        </div>
        <div class="text-[10px] uppercase opacity-80">horas</div>
      </div>
      <div class="text-4xl opacity-50">:</div>
      <div class="text-center">
        <div class="font-mono text-5xl font-black tabular-nums">
          {{ formatted(parts.minutes) }}
        </div>
        <div class="text-[10px] uppercase opacity-80">min</div>
      </div>
      <div class="text-4xl opacity-50">:</div>
      <div class="text-center">
        <div class="font-mono text-5xl font-black tabular-nums">
          {{ formatted(parts.seconds) }}
        </div>
        <div class="text-[10px] uppercase opacity-80">seg</div>
      </div>
    </div>

    <div v-else class="text-sm opacity-80">
      Defina a data da eleição nas configurações da campanha.
    </div>

    <div v-if="electionDate" class="mt-3 text-[11px] opacity-80">
      {{
        new Date(electionDate).toLocaleDateString('pt-BR', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })
      }}
    </div>
  </div>
</template>
